<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="50" cy="50" r="32" stroke="black" stroke-width="4"/>
<path d="M39.5926 31L49.9259 45.9259L60.2593 31" stroke="black" stroke-width="4"/>
<path d="M49.9259 69.463V44.7778" stroke="black" stroke-width="4"/>
<path d="M35 45.9259H66M35 56.2593H66" stroke="black" stroke-width="4"/>
</svg>

</template>
